import { useState, useEffect } from "react";

/**
 * useIsMobile — Tailwind md: 분기점(768px)과 정확히 일치하는 모바일 판정.
 *
 * ★matchMedia 기반(2026-06): 종전 window.innerWidth 는 스크롤바 폭을 포함해
 *   CSS @media(min-width:768) 와 미세하게 어긋남 → 768 부근에서 모바일헤더+데스크톱테이블
 *   동시 표시(탭/테이블 겹침) 버그. matchMedia 는 CSS 미디어쿼리와 동일 뷰포트 계산 → 일치.
 *   md: = min-width 768px 이므로 모바일 = max-width 767.98px.
 */
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 0.02}px)`;
  const get = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : false;
  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    const handler = () => setIsMobile(mq.matches);
    handler();
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, [query]);

  return isMobile;
}
